module.exports = __webpack_public_path__ + "static/media/photo_resume.c0d12edf.webp";